module.exports = __webpack_public_path__ + "427e609ec4f00ae75fb8075e6a6c55e3.svg";


//////////////////
// WEBPACK FOOTER
// ./less/fonts/fiveringsdb.svg?yn5wqh
// module id = 1242
// module chunks = 0